import isArrayLike from './is-array-like';

const contains = function(arr: any[], value: any): boolean {
  if (!isArrayLike(arr)) {
    return false;
  }
  return arr.indexOf(value) > -1;
};

export default contains;
